<template>
  <div>
    <v-layout wrap>
      <v-flex xs3 style="display: flex; align-items: center"> วันที่ต้องการจัดส่ง: </v-flex>
      <v-flex xs9>
        <template v-if="!isEdit">
          <span class="primary--text">{{ computedShippingDate }}</span>
          <v-btn flat fab small color="primary" class="ma-0" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
      </v-flex>
      <v-flex v-if="isEdit" xs12>
        <div class="form-control" style="position: relative">
          <VueCtkDateTimePicker
            v-model="input.shipping_date"
            color="#ff706b"
            locale="en"
            no-label
            no-clear-button
            :min-date="currentDate"
            :format="dateFormat"
            :formatted="dateFormated"
            :only-date="onlyDate"
          />
        </div>
        <div>
          <v-btn outline small color="grey" @click="isEdit = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn outline small color="primary" @click="saveChange">
            <span class="fa fa-pencil-alt mr-2"></span> {{ $t('Save') }}
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    VueCtkDateTimePicker
  },
  props: {
    shippingDate: { default: null },
    shippingTime: { default: null },
    isDateTime: { default: true, type: Boolean }
  },
  data() {
    return {
      isEdit: false,
      input: {
        shipping_date: moment().format('YYYY-MM-DD 00:00')
      }
    }
  },
  computed: {
    dateFormat() {
      return this.isDateTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
    },
    dateFormated() {
      return this.isDateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
    },
    onlyDate() {
      return this.isDateTime ? false : true
    },
    currentDate() {
      return moment().format('YYYY-MM-DD 00:00')
    },
    computedShippingDate() {
      return this.shippingDate ? moment(this.shippingDate).format(this.dateFormated) : ''
    }
  },
  mounted() {
    if (this.shippingDate) {
      this.input.shipping_date = moment(this.shippingDate).format(this.dateFormat)
    }
  },
  methods: {
    saveChange() {
      this.isEdit = false
      this.$emit('edited', this.input)
    }
  }
}
</script>

<style lang="scss">
.custom-select.v-text-field--outline > .v-input__control > .v-input__slot {
  border-radius: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SetShippingDatetime.vue